export const useGetTopicsId = (): number | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const { pathname } = window.location;

  const topicIdRouteRegex = pathname.match(/\/networks\/\d+\/topics\/(\d+)/);

  if (!topicIdRouteRegex) {
    return undefined;
  }

  return parseInt(topicIdRouteRegex[1], 10);
};
